const SHOW_LOADING = 'SHOW_LOADING';


const _loading = (show) => ({
    type: SHOW_LOADING,
    payload: {
        show,
    }
});

export {
    SHOW_LOADING,
    _loading
}